import { render, staticRenderFns } from "./DashboardTemplateSMS.vue?vue&type=template&id=9b046ca4&"
import script from "./DashboardTemplateSMS.vue?vue&type=script&lang=js&"
export * from "./DashboardTemplateSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports